import { CardWrapper } from "Components/Common/Card/index";
import { Hr } from "Components/Common/Hr/index";
import { Spacer } from "Components/Common/Spacer/index";
import { TypographyT56 } from "Components/Common/Typography/index";
import { isDesmetSupplier } from "Utils/index";
import React, { Fragment } from "react";

const CardT5 = (props) => {
  const { supplier_instruction, handleOnChangeForSupplierInstruction } = props;
  return (
    <Fragment>
      <CardWrapper>
        <TypographyT56>Special Instructions</TypographyT56>
        <Hr />
        <Spacer spacing={"6px"} />
        <Fragment>
          <textarea
            className=""
            style={{ width: "100%", height: "50px" }}
            name="supplier_instruction"
            placeholder="Enter here..."
            value={supplier_instruction}
            onChange={handleOnChangeForSupplierInstruction}
            disabled = {!isDesmetSupplier()}
          />
        </Fragment>
      </CardWrapper>
    </Fragment>
  );
};

export default CardT5;
